import { apiClient } from './client';
import { EmailCampaign, EmailMessage } from '../types/communications';

export const listEmailHistory = async (leadId: number): Promise<EmailMessage[]> => {
  const { data } = await apiClient.get(`/email/leads/${leadId}/messages`);
  return data.data;
};

export interface SendEmailPayload {
  leadId?: number;
  toEmail?: string;
  templateId?: number;
  subject?: string;
  body?: string;
  attachmentIds?: number[];
}

export const sendEmail = async (payload: SendEmailPayload): Promise<EmailMessage> => {
  const { data } = await apiClient.post('/email/send', payload);
  return data.data;
};

export const listCampaigns = async (): Promise<EmailCampaign[]> => {
  const { data } = await apiClient.get('/email/campaigns');
  return data.data;
};

export interface CreateCampaignPayload {
  name: string;
  templateId: number;
  subjectOverride?: string;
  audienceFilter?: Record<string, number>;
}

export const createCampaign = async (payload: CreateCampaignPayload): Promise<EmailCampaign> => {
  const { data } = await apiClient.post('/email/campaigns', payload);
  return data.data;
};

export const sendCampaign = async (id: number): Promise<EmailCampaign> => {
  const { data } = await apiClient.post(`/email/campaigns/${id}/send`);
  return data.data;
};
